// import COLORS from "../../styles/colors";
import styled from "@emotion/styled";
import { fontSize, respSize} from "../../utils/Dimension";

// input field on the header
export const InputWapper = styled.div`
  --color-white: #fff;
  --color-text: #404040;

  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: var(--color-white);
  border-radius: 4px;
  
  width: 100%;
`;


export const Input = styled.input`
  display: inline-block;
  min-width: 100%;
  background-color: var(--color-white);
  color: var(--color-text);
  font-size: .875em;
  padding: ${fontSize(7)} ${fontSize(8)};
  flex: 1;
  border-radius: 4px;
  border: ${({ onChangeFocus }) =>
          onChangeFocus === true ? "1px solid rgba(64, 64, 64)" : "1px solid #ACC1D1"};

  &::placeholder {
    color: #ACC1D1;
    opacity: 1;
  }
  &:focus {
    border: 1px solid rgba(64, 64, 64);
    outline: none;
  }
`;

export const TextArea = styled.input`
  display: inline-block;
  // min-width: ${respSize(300)};
  min-width: 100%;
  background-color: var(--color-white);
  color: var(--color-text);
  //font-size: ${fontSize(14)};
  font-size: .875em;
  padding: ${fontSize(8)} ${fontSize(8)};
  //line-height: ${respSize(24)};
  flex: 1;
  border-radius: 4px;
  //border: none;
  border: ${({ onChangeFocus }) =>
          onChangeFocus === true ? "1px solid rgba(64, 64, 64)" : "1px solid #ACC1D1"};

  &::placeholder {
    color: #ACC1D1;
    opacity: 1;
  }
  &:focus {
    border: 1px solid rgba(64, 64, 64);
    outline: none;
  }
`;

export const Select = styled.select`
  display: inline-block;
  //min-width: ${respSize(300)};
  min-width: 100%;
  background-color: var(--color-white);
  color: var(--color-text);
  border-radius: 4px;
  //font-size: ${fontSize(14)};
  font-size: .875em;
  padding: ${fontSize(8)} ${fontSize(8)};
  //line-height: ${respSize(24)};
  flex: 1;
  //border: none;
  border: ${({ onChangeFocus }) =>
          onChangeFocus === true ? "1px solid rgba(64, 64, 64)" : "1px solid #ACC1D1"};

  &::placeholder {
    color: #ACC1D1;
    opacity: 1;
  }
  &:focus {
    border: 1px solid rgba(64, 64, 64);
    outline: none;
  }
`;

export const ButtonInput = styled.input`
    display: inline-block;
    min-width: 100%;
    background-color: var(--color-white);
    color: var(--color-text);
    font-size: .875em;
    padding: ${fontSize(7)} ${fontSize(8)};
    flex: 1;
    border-radius: 4px;
    border: ${({ onChangeFocus }) =>
            onChangeFocus === true ? "1px solid rgba(64, 64, 64)" : "1px solid #ACC1D1"};

    &::placeholder {
    color: #ACC1D1;
    opacity: 1;
    }
    &:focus {
    border: 1px solid rgba(64, 64, 64);
    outline: none;
    }
    &button {
        font-size: 12px;
        padding: 6px 20px;
        border-radius: 4px;
        background-color: #404040;
        right: 20px;
        top: auto;
        bottom: auto;
    }
`;
